import { render, staticRenderFns } from "./AppFooterRuijin.vue?vue&type=template&id=280aac18&scoped=true&"
import script from "./AppFooterRuijin.vue?vue&type=script&lang=js&"
export * from "./AppFooterRuijin.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterRuijin.vue?vue&type=style&index=0&id=280aac18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280aac18",
  null
  
)

export default component.exports